function recuperaErros() {
  //ERROS EXTRAÍDOS DO ARQUIVO FACETECPUBLICAPI.D.TS
  const errorsFacetec = {
    1: {
      msgOriginal: `The Session was cancelled because not all guidance images were configured.`,
      msgTraduzida: `A Sessão foi cancelada porque nem todas as imagens de orientação foram configuradas.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 1,
    },
    2: {
      msgOriginal: `The Session was cancelled because the user was unable to complete a Session in the default allotted time or the timeout set by the developer.`,
      msgTraduzida: `IDENTIFIÇÃO CANCELADA POR TEMPO EXCEDIDO`,
      privado: false,
      renderRedirect: "renderSessionExpired",
      codigo: 2,
    },
    3: {
      msgOriginal: `The Session was cancelled due to the app being terminated, put to sleep, an OS notification, or the app was placed in the background.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - SAIU DO NAVEGADOR`,
      privado: false,
      renderRedirect: "renderConnectionInterrupted",
      codigo: 3,
    },
    4: {
      msgOriginal: `The developer programmatically called the Session cancel API.`,
      msgTraduzida: `O desenvolvedor chamou programaticamente a API de cancelamento de sessão.`,
      privado: true,
      renderRedirect: "renderConnectionInterrupted",
      codigo: 4,
    },
    5: {
      msgOriginal: `The Session was cancelled due to a device orientation change during the Session.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - MUDOU A ORIENTAÇÃO DO NAVEGADOR`,
      privado: false,
      renderRedirect: "renderConnectionInterrupted",
      codigo: 5,
    },
    6: {
      msgOriginal: `The Session was cancelled because device is in landscape mode. The user experience of devices in these orientations is poor and thus portrait is required.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - MODO PAISAGEM`,
      privado: false,
      renderRedirect: "renderConnectionInterrupted",
      codigo: 6,
    },
    7: {
      msgOriginal: `The user pressed the cancel button and did not complete the Session.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USUÁRIO CANCELOU`,
      privado: false,
      renderRedirect: "renderCancel",
      codigo: 7,
    },
    8: {
      msgOriginal: `The user pressed the cancel button during New User Guidance.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USUÁRIO CANCELOU`,
      privado: false,
      renderRedirect: "renderCancel",
      codigo: 7,
    },
    9: {
      msgOriginal: `The user pressed the cancel button during Retry Guidance.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USUÁRIO CANCELOU`,
      privado: false,
      renderRedirect: "renderCancel",
      codigo: 7,
    },
    10: {
      msgOriginal: `The user cancelled out of the the FaceTec Browser SDK experience while attempting to get camera permissions.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USUÁRIO NEGOU PERMISSÃO DA CÂMERA`,
      privado: false,
      renderRedirect: "renderAccessCam",
      codigo: 8,
    },
    11: {
      msgOriginal: `The Session was cancelled because the user was in a locked out state.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USUÁRIO EXCEDEU LIMITE DE TENTATIVAS`,
      privado: false,
      renderRedirect: "renderLimitAccess",
      codigo: 9,
    },
    12: {
      msgOriginal: `The Session was cancelled because camera was not enabled.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - CÂMERA NÃO HABILITADA`,
      privado: false,
      renderRedirect: "renderAccessCam",
      codigo: 10,
    },
    13: {
      msgOriginal: `This status will never be returned in a properly configured or production app. This status is returned if your Key is invalid or network connectivity issues occur during a session when the application is not in production.`,
      msgTraduzida: `Esse status nunca será retornado em um aplicativo configurado ou em produção corretamente. Esse status é retornado se sua chave for inválida ou ocorrerem problemas de conectividade de rede durante uma sessão quando o aplicativo não estiver em produção.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 11,
    },
    14: {
      msgOriginal: `The Session was cancelled because the FaceTec Browser SDK cannot be rendered when the document is not ready.`,
      msgTraduzida: `A Sessão foi cancelada porque o FaceTec Browser SDK não pode ser renderizado quando o documento não está pronto.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 12,
    },
    15: {
      msgOriginal: `The Session was cancelled because there was another Session in progress.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - EXISTE OUTRA SESSÃO ATIVA`,
      privado: false,
      renderRedirect: "render500",
      codigo: 13,
    },
    16: {
      msgOriginal: `The Session was cancelled because the selected camera is not active.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - CÂMERA NÃO ATIVA`,
      privado: false,
      renderRedirect: "renderAccessCam",
      codigo: 14,
    },
    17: {
      msgOriginal: `The Session was cancelled because initialization has not been completed yet.`,
      msgTraduzida: `A Sessão foi cancelada porque a inicialização ainda não foi concluída.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 15,
    },
    18: {
      msgOriginal: `The Session was cancelled because of an unknown and unexpected error. The FaceTec Browser SDK leverages a variety of platform APIs including camera, storage, security, networking, and more. This return value is a catch-all for errors experienced during normal usage of these APIs.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - ERRO INTERNO`,
      privado: false,
      renderRedirect: "render500",
      codigo: 16,
    },
    19: {
      msgOriginal: `The Session cancelled because user pressed the Get Ready screen subtext message. Note: This functionality is not available by default, and must be requested from FaceTec in order to enable.`,
      msgTraduzida: `A sessão foi cancelada porque o usuário pressionou a mensagem de subtexto da tela Get Ready. Nota: Esta funcionalidade não está disponível por padrão e deve ser solicitada à FaceTec para habilitar.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 17,
    },
    20: {
      msgOriginal: `The Session was cancelled, the FaceTec Browser SDK was opened in an Iframe without an Iframe constructor.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USO EM IFRAME`,
      privado: true,
      renderRedirect: "render500",
      codigo: 18,
    },
    21: {
      msgOriginal: `The Session was cancelled, the FaceTec Browser SDK was not opened in an Iframe with an Iframe constructor.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USO EM IFRAME`,
      privado: true,
      renderRedirect: "render500",
      codigo: 18,
    },
    22: {
      msgOriginal: `The Session was cancelled, the FaceTec Browser SDK was not opened in an Iframe without permission.`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USO EM IFRAME`,
      privado: true,
      renderRedirect: "render500",
      codigo: 18,
    },
    23: {
      msgOriginal: `FaceTec SDK is still loading resources.`,
      msgTraduzida: `FaceTec SDK ainda está carregando recursos.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 19,
    },
    24: {
      msgOriginal: `FaceTec SDK could not load resources.`,
      msgTraduzida: `FaceTec SDK não pôde carregar recursos.`,
      privado: true,
      renderRedirect: "render500",
      codigo: 20,
    },
    25: {
      msgOriginal: `The Session was cancelled because a full screen mode change was detected in an IFrame`,
      msgTraduzida: `IDENTIFICAÇÃO CANCELADA - USO EM IFRAME`,
      privado: true,
      renderRedirect: "render500",
      codigo: 18,
    },
  };
  return errorsFacetec;
}

exports.recuperaErros = recuperaErros;
